// extracted by mini-css-extract-plugin
module.exports = {"loading":"Router_loading__2ZS70"};